import React, { Suspense, lazy } from 'react';
import { useMediaQuery } from 'react-responsive';
import SkeletonItem from './SkeletonItem/SkeletonItem.jsx';
import SkeletonItemMoby from './SkeletonItem/SkeletonItemMoby.jsx';


const ItemContainer = lazy(() => import('./ItemContainer/ItemContainer.jsx'))
const ItemContainerMoby = lazy(() => import('./ItemContainerMoby/ItemContainerMoby.jsx'))

const ItemDisplay = (props) =>{
    const isDesktopOrLaptop = useMediaQuery({ minWidth: 1224 })
    const isTabletOrMobile = useMediaQuery({ maxWidth: 1223 })
    // const isBigScreen = useMediaQuery({ minWidth: 1824 })
    // const isPortrait = useMediaQuery({ orientation: 'portrait' })
    // const isRetina = useMediaQuery({ minResolution: '2dppx' })

    return (
        <>
        {isDesktopOrLaptop && <Suspense fallback={<SkeletonItem/>}><ItemContainer {...props} /></Suspense>}
        {isTabletOrMobile && <Suspense fallback={<SkeletonItemMoby/>}><ItemContainerMoby {...props} /></Suspense>}
        {/* {isPortrait   &&  <BlockDisplayMoby {...props}/> } */}
        </>
    )
}

export default ItemDisplay;